import React from "react";
import { Volume2, VolumeX, X } from "lucide-react";
import { useMusic } from "@/context/MusicContext";

/**
 * Tiny sleek floating music control — bottom-right area, just above the
 * Emergent badge. Pink glass pill (~38px tall). Two icons: mute/unmute and ×.
 * No player UI, no song list, no big block. Just a sleek mute/close control.
 */
export default function MusicWidget() {
  const { ready, muted, closed, setMuted, close } = useMusic();
  if (closed) return null;

  return (
    <div
      className="fixed z-[55]"
      style={{ bottom: "70px", left: "20px" }}
      data-testid="music-widget"
    >
      <div
        className="glass-panel rounded-full flex items-center gap-1 pl-3 pr-1.5 py-1 border-pink-hot/40"
        style={{ filter: "drop-shadow(0 4px 10px rgba(255,20,147,0.25))" }}
      >
        <button
          onClick={() => setMuted(!muted)}
          className="flex items-center gap-2 text-pink-blush hover:text-pink-hot transition-colors"
          data-testid="music-toggle"
          aria-label={muted ? "Unmute music" : "Mute music"}
        >
          {muted ? (
            <VolumeX className="w-4 h-4" />
          ) : (
            <Volume2 className="w-4 h-4 text-pink-hot" />
          )}
          <span className="text-[9px] tracking-[0.28em] uppercase">
            {muted ? "Music off" : "Music on"}
          </span>
          {!muted && ready && (
            <span className="w-1.5 h-1.5 bg-pink-hot rounded-full animate-pink-pulse" />
          )}
        </button>
        <button
          onClick={close}
          className="text-champagne/50 hover:text-pink-hot p-1"
          data-testid="music-close"
          aria-label="Close music player"
        >
          <X className="w-3 h-3" />
        </button>
      </div>
    </div>
  );
}
